import React from 'react';
import FoxChickenGrainGame from './FoxChickenGrainGame';

function App() {
  return (
    <div className="App">
      <FoxChickenGrainGame />
    </div>
  );
}

export default App;
